(() => {
  'use strict';

  /* Drives any horizontal rail: the review carousel and the product carousel both
     use it. The track scrolls natively, so this only moves it by one "page" and
     keeps the arrow disabled states honest. */
  class MetaseryRail extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';

      this.track = this.querySelector('[data-rail-track]');
      this.prev = this.querySelector('[data-rail-prev]');
      this.next = this.querySelector('[data-rail-next]');
      if (!this.track) return;

      this.prev?.addEventListener('click', () => this.page(-1));
      this.next?.addEventListener('click', () => this.page(1));

      this.sync = this.sync.bind(this);
      this.track.addEventListener('scroll', () => {
        if (this.frame) return;
        this.frame = window.requestAnimationFrame(() => { this.frame = null; this.sync(); });
      }, { passive: true });

      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(this.sync);
        this.observer.observe(this.track);
      }
      this.sync();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      if (this.frame) window.cancelAnimationFrame(this.frame);
    }

    page(direction) {
      // One item plus its gap, so the rail lands on a snap point rather than mid-card.
      const first = this.track.firstElementChild;
      const step = first
        ? first.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap || 0)
        : this.track.clientWidth * 0.8;
      this.track.scrollBy({ left: step * direction, behavior: 'smooth' });
    }

    sync() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      const x = this.track.scrollLeft;
      if (this.prev) this.prev.disabled = x <= 2;
      if (this.next) this.next.disabled = x >= max - 2;
    }
  }

  if (!customElements.get('metasery-rail')) customElements.define('metasery-rail', MetaseryRail);
})();
